import axios from "axios";
import { API_BASE_URL } from "../config/config.js";
import { fetchSession, getCsrfToken, login } from "./session.js";

const UNSAFE_METHODS = ["post", "put", "patch", "delete"];

// Only our own backend API gets the cookie. External URLs (S3 presigned
// downloads, Graph...) and public SPARQL must NOT send credentials.
const isBackendApi = (url = "") =>
  url.startsWith(API_BASE_URL) && !url.startsWith(`${API_BASE_URL}/sparql`);

axios.interceptors.request.use((config) => {
  if (isBackendApi(config.url)) {
    config.withCredentials = true;
    const method = (config.method || "get").toLowerCase();
    const token = getCsrfToken();
    if (UNSAFE_METHODS.includes(method) && token) {
      config.headers = { ...config.headers, "X-CSRF-Token": token };
    }
  }
  return config;
});

axios.interceptors.response.use(undefined, async (error) => {
  const { config, response } = error;
  if (!config || !response || !isBackendApi(config.url)) throw error;

  // CSRF token missing/stale: fetch a fresh one and retry once.
  if (
    response.status === 403 &&
    response.data?.detail === "CSRF validation failed" &&
    !config._csrfRetried
  ) {
    config._csrfRetried = true;
    await fetchSession();
    return axios(config);
  }

  // Session expired (idle 1h / absolute 8h) while the user was logged in.
  // Not for /auth/session (that's how we learn we're logged out) or
  // /auth/logout (logout() navigates to / itself).
  if (
    response.status === 401 &&
    getCsrfToken() &&
    !config.url.endsWith("/auth/session") &&
    !config.url.endsWith("/auth/logout")
  ) {
    login();
  }
  throw error;
});